import React from 'react';
import { ITooltip } from './tooltip';
import TooltipPopover from './popover';
import TooltipPopup from './popup';
import Icon from './icon';

const Tooltip: React.FC<ITooltip> = ({
	children,
	icon,
	title,
	className,
	modal,
	scroll,
	event,
	fieldname,
}) => {
	return (
		<>
			{modal ? (
				<TooltipPopup
					icon={icon || <Icon />}
					title={title}
					className={className}
					fieldname={fieldname}
					scroll={scroll}>
					{children}
				</TooltipPopup>
			) : (
				<TooltipPopover
					icon={icon || <Icon />}
					title={title}
					event={event}
					className={className}
					fieldname={fieldname}>
					{children}
				</TooltipPopover>
			)}
		</>
	);
};

export default Tooltip;
